import React from "react";
import { Box } from "@mui/material";
import styled from "@emotion/styled";
import { STORAGE_URL } from "../../constants";
import { ConnectButton } from "@rainbow-me/rainbowkit";
import { useAuth } from "../../context/authContext";

const Root = styled("div")(({ height, theme, width, full }) => ({
  alignItems: "center",
  paddingInline: "20px",
  backgroundImage: `url(${STORAGE_URL}yuga/icons/connectBtnBg.png)`,
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  height: height || "85px",
  width: width || "194px",
  padding: "28px",
  cursor: "var(--pointer-cursor)",
  display: "flex",
  alignContent: "center",
  justifyContent: "center",
  [theme.breakpoints.down("sm")]: {
    paddingInline: "5px",
    height: "40px",
    minWidth: "110px",
  },

  "& .MuiBox-root": {
    fontWeight: "600",
    textTransform: "capitalize",
    fontFamily: "var(--font-g)",
    fontSize: "22px",
    color: "#adadaf",
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px",
    },
  },
}));

const WalletConnectButton = ({
  className,
  full,
  height,
  width,
  style,
  ...rest
}) => {
  const { handleAuth, logout, user } = useAuth();

  return (
    <ConnectButton.Custom>
      {({
        account,
        chain,
        openAccountModal,
        openChainModal,
        openConnectModal,
        authenticationStatus,
        mounted,
      }) => {
        const ready = mounted && authenticationStatus !== "loading";
        const connected =
          ready &&
          account &&
          chain &&
          (!authenticationStatus || authenticationStatus === "authenticated");

        const handleClick = () => {
          if (!connected) {
            if (user?.role === "admin") {
              return logout();
            }
            return openConnectModal();
          } else if (
            connected &&
            user?.address === "0x0000000000000000000000000000000000000000"
          ) {
            return handleAuth();
          }

          if (chain.unsupported) {
            return openChainModal();
          }

          return openAccountModal();
        };

        return (
          <Root
            style={style}
            full={full}
            width={width}
            height={height}
            className={className}
            onClick={handleClick}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                height: "100%",
              }}
              {...(!ready && {
                "aria-hidden": true,
                sx: {
                  opacity: 0,
                  pointerEvents: "none",
                  userSelect: "none",
                },
              })}
            >
              {(() => {
                if (!connected) {
                  return user?.role === "admin" ? "Logout" : "Connect Wallet";
                } else if (
                  connected &&
                  user?.address === "0x0000000000000000000000000000000000000000"
                ) {
                  return "Sign In";
                }

                if (chain.unsupported) {
                  return "Wrong network";
                }

                return account.ensName ? account.ensName : account.displayName;
              })()}
            </Box>
          </Root>
        );
      }}
    </ConnectButton.Custom>
  );
};

export default WalletConnectButton;
